import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

const sendSignedProposal = (data: any): Promise<unknown> => {
  return axios.post(`/orders/proposals/${data.proposalId}/signature`, data)
}

export function useSendSignedProposal() {
  const queryClient = useQueryClient()
  return useMutation(sendSignedProposal, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries('loadAutentiqueSignedProposals')
      queryClient.invalidateQueries('loadHandSignedProposals')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível enviar o orçamento assinado!')
    }
  })
}
